var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "vechile-seal-inscan"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('fieldset', [_c('div', {
    staticClass: "card-body1"
  }, [_c('legend', [_vm._v("Vehicle Seal InScan")]), _vm._v(" "), _c('b-card', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-body1"
  }, [_c('div', {
    staticClass: "form group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Trip ID")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-truck'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tripno),
      expression: "tripno"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Trip ID",
      "id": "tripno",
      "name": "tripno"
    },
    domProps: {
      "value": (_vm.tripno)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getTripDetails.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tripno = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.TripIdError) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.TripIdError))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "margin-top": "30px",
      "margin-left": "-13px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.getTripDetails
    }
  }, [_vm._v("Search")]), _vm._v(" "), _c('button', {
    staticClass: "common-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_vm._v("Reset")])])]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onsubmit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Connection Name")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-map-signs'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fullconnectionname),
      expression: "fullconnectionname"
    }],
    class: {
      'form-control': true
    },
    staticStyle: {
      "background-color": "rgb(237, 238, 238)"
    },
    attrs: {
      "type": "text",
      "readonly": "",
      "placeholder": "Full Connection Name",
      "name": "connectionname",
      "id": "connectionname"
    },
    domProps: {
      "value": (_vm.fullconnectionname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fullconnectionname = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Current TouchPoint")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-university'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currenttouchpoint),
      expression: "currenttouchpoint"
    }],
    class: {
      'form-control': true
    },
    staticStyle: {
      "background-color": "rgb(237, 238, 238)"
    },
    attrs: {
      "type": "text",
      "readonly": "",
      "placeholder": "Current TouchPoint",
      "name": "currenttouchpoint",
      "id": "currenttouchpoint"
    },
    domProps: {
      "value": (_vm.currenttouchpoint)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currenttouchpoint = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("TouchPoints")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-group'></i>"
    }
  }, [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    attrs: {
      "options": _vm.touchpointlist,
      "selected-option": _vm.touchpointlistitem,
      "name": "TouchPoint",
      "id": "touchPointHubId",
      "placeholder": "Select Touch Point"
    },
    on: {
      "select": _vm.selectTouchPoint
    },
    model: {
      value: (_vm.touchPointHubId),
      callback: function($$v) {
        _vm.touchPointHubId = $$v
      },
      expression: "touchPointHubId"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('TouchPoint')),
      expression: "errors.has('TouchPoint')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('TouchPoint')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Vehicle InScan Time")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar-o'></i>"
    }
  }, [_c('date-picker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    attrs: {
      "lang": "en",
      "type": "datetime",
      "minute-step": _vm.step,
      "name": "VehicleInScanTime",
      "not-before": _vm.inscanDateTimeRange,
      "not-after": _vm.schedulecreateddate,
      "value-type": "format",
      "format": "YYYY-MM-DD HH:mm"
    },
    model: {
      value: (_vm.vecInScantime),
      callback: function($$v) {
        _vm.vecInScantime = $$v
      },
      expression: "vecInScantime"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('VehicleInScanTime')),
      expression: "errors.has('VehicleInScanTime')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('VehicleInScanTime')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Ops Ticket No.")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-archive'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ticketno),
      expression: "ticketno"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Ticket number",
      "name": "Ticketno",
      "id": "ticketno"
    },
    domProps: {
      "value": (_vm.ticketno)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ticketno = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Ticketno')),
      expression: "errors.has('Ticketno')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Ticketno')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-input-group', [_c('b-button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "background-color": "rgb(60, 126, 197)",
      "border-color": "rgb(60, 126, 197)",
      "color": "white"
    },
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Inscan")])], 1)], 1)])])], 1)], 1)])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c6533f0","hasScoped":true}!./src/views/components/VehicleSealInScan/VehicleSealInScan.html
// module id = 1954
// module chunks = 2